/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
if (process.env.DEVTOOLS_ENABLED) {
  angular.module('bulbApp.devToolsModule')
    .controller('DevToolsController', ['$translate','$window','Restangular','BulbAuthService','BulbBusyService','BulbErrorService','BulbGroupService', 'CONFIG', DevToolsController]);

  function DevToolsController($translate, $window, Restangular, BulbAuthService,
                BulbBusyService, BulbErrorService, BulbGroupService, CONFIG) {

    this.status = '';
    var that = this;
    this.account = BulbAuthService.currentUser;
    this.isPDFSnapshotEnabled = this.account.features.SnapshotPdfFeature.enabled;
    this.pdfSnapshotLabel =
      $translate.instant((that.isPDFSnapshotEnabled) ? 'devtools_pdf_snapshot_disable' : 'devtools_pdf_snapshot_enable');
    this.softDeleteSeconds = this.account.prefs.softDeleteSeconds;
    this.hardDeleteSeconds = this.account.prefs.hardDeleteSeconds;
    this.uniquePathPrefix = '';
    this.migrator = '';
    this.migratorStatusName = '';
    this.migratorStatus = null;
    this.errorMessage = '';
    this.isFreeAccount = this.account.type === 'FREE';
    this.reCaptchaEnabled = CONFIG.reCaptcha.enabled;
    this.spamFeatureEnabled = "";

    this.deleteCurrentAccount = function () {
      BulbBusyService.showBusyDuring(
        Restangular.one('/devtools/accounts/' + that.account.id).remove()
          .then(function () {
            BulbAuthService.signOut('/b/bootstrap');
          }, function (error) {
            BulbErrorService.showError(error);
          })
      );
    };

    this.userDeleteAccount = function () {
      BulbBusyService.showBusyDuring(
        Restangular.one('/accounts/' + that.account.id).remove()
          .then(function () {
            BulbAuthService.signOut('/b/bootstrap');
          }, function (error) {
            BulbErrorService.showError(error);
          })
      )
    }

    this.subscribeToBulb = function () {
      BulbBusyService.showBusyDuring(
        Restangular.one('devtools', 'subscribe').get()
          .then(function (response) {
            BulbAuthService.setCurrentUser(response);
            that.isFreeAccount = false;
          }, function (error) {
            BulbErrorService.error(error);
          })
      );
    };

    this.unsubscribeFromBulb = function () {
      BulbBusyService.showBusyDuring(
        Restangular.one('devtools', 'unsubscribe').get()
          .then(function (response) {
            BulbAuthService.setCurrentUser(response);
            that.isFreeAccount = true;
          }, function (error) {
            BulbErrorService.error(error);
          })
      );
    };

    this.toggleEmailVerification = function (emailIndex) {
      if (that.account.emails) {
        var emailToToggle = that.account.emails[emailIndex].email;
        BulbBusyService.showBusyDuring(
          Restangular.all('devtools/toggleEmailVerification').post({ emailToToggle: emailToToggle })
            .then(function (response) {
                BulbAuthService.setCurrentUser(response);
              }, function (error) {
                BulbErrorService.error(error);
              }
            )
        );
      }
    };

    this.toggleCodesFeature = function () {
      if (that.account.id) {
        BulbBusyService.showBusyDuring(
          Restangular.all('devtools/toggleCodesFeature').post()
            .then(function (response) {
              BulbAuthService.setCurrentUser(response);
              $window.location.reload();
            }, function (error) {
              BulbErrorService.error(error);
            })
        );
      }
    };

    this.toggleOnboardingCompletion = function () {
      BulbBusyService.showBusyDuring(
        Restangular.all('devtools/toggleOnboardingCompletion').post()
          .then(function (response) {
            BulbAuthService.setCurrentUser(response);
          }, function (error) {
            BulbErrorService.error(error);
          })
      );
    };

    /**
     * Returns true if the onboarding tour is completed for the user.
     * @returns {string} for onboarding status
     */
    this.isOnboardingComplete = function () {
      var userOnboardingPrefs = that.account.prefs.onBoarding;
      var isOnboardingComplete = !(userOnboardingPrefs.onboardingShowMainTour ||
        userOnboardingPrefs.onboardingShowMenuTour || userOnboardingPrefs.onboardingShowPageTour);
      return (isOnboardingComplete) ? 'devtools_onboarding_off' : 'devtools_onboarding_on';
    };

    this.toggleOffBoardingPrefs = function () {
      BulbBusyService.showBusyDuring(
        Restangular.all('devtools/toggleOffBoardingPrefs').post()
          .then(function (response) {
            BulbAuthService.setCurrentUser(response);
          }, function (error) {
            BulbErrorService.error(error);
          })
      );
    };

    this.runOffBoardingInauguration = function () {
      BulbBusyService.showBusyDuring(
        Restangular.all('devtools/offboarding_inauguration').post()
          .then(function (response) {
            that.hasOffBoardingInaugurationBeenRun();
            BulbAuthService.setCurrentUser(response);
          }, function (error) {
            BulbErrorService.error(error);
          })
      );
    };

    this.hasOffBoardingInaugurationBeenRun = function () {
      BulbBusyService.showBusyDuring(
        Restangular.one('devtools/offboarding_inauguration_has_been_run').get()
          .then(function (response) {
            that.statusOfOffBoarding = response.status;
          }, function (error) {
            BulbErrorService.error(error);
          })
      );
    };

    this.togglePDFSnapshots = function () {
      BulbBusyService.showBusyDuring(
        Restangular.all('devtools/togglePDFSnapshot').post()
          .then(function (response) {
            BulbAuthService.setCurrentUser(response);
            that.isPDFSnapshotEnabled = !that.isPDFSnapshotEnabled;
            that.pdfSnapshotLabel =
              $translate.instant(
                (that.isPDFSnapshotEnabled) ? 'devtools_pdf_snapshot_disable' : 'devtools_pdf_snapshot_enable');
          }, function (error) {
            BulbErrorService.error(error);
          })
      );
    };

    this.deleteGroups = function () {
      BulbBusyService.showBusyDuring(
        Restangular.one('/devtools/groups').remove()
          .then(function (response) {
            BulbAuthService.setCurrentUser(response);
            BulbGroupService.deletedGroupUsingDevTool = true;
            BulbGroupService.fetchGroups();
          }, function (error) {
            BulbErrorService.showError(error);
          })
      );
    };

    this.setStorageLimit = function () {

      BulbBusyService.showBusyDuring(
        Restangular.all('devtools/setStorageLimit')
          .post({}).then(function (response) {
            BulbAuthService.setCurrentUser(response);
          }, function (error) {
            if (error.data && error.data.developerMessage) {
              BulbErrorService.showError($translate.instant(error.data.developerMessage));
            }
          }
        )
      );
    };

    this.validate = function (v1, v2) {
      var reg = /^[0-9]*$/;

      if (v1 === undefined || v2 === undefined || !reg.test(v1) || !reg.test(v2) || v1 <= 0 || v2 <= 0) {
        return 'soft_delete_invalid';
      }

      return false;
    };

    this.setSoftDeleteValues = function (isReset) {
      that.errorMessage = '';
      if (isReset) {
        that.softDeleteSeconds = 0;
        that.hardDeleteSeconds = 0;
      } else {
        var errorKey = this.validate(this.softDeleteSeconds, this.hardDeleteSeconds);
        if (errorKey) {
          that.errorMessage = $translate.instant(errorKey);
          return;
        }
      }

      BulbBusyService.showBusyDuring(
        Restangular.all('devtools/setSoftDeleteValues')
          .post({ softDeleteSeconds: that.softDeleteSeconds, hardDeleteSeconds: that.hardDeleteSeconds })
          .then(function (response) {
              BulbAuthService.setCurrentUser(response);
            }, function (error) {
              if (error.data && error.data.developerMessage) {
                that.errorMessage = $translate.instant(error.data.developerMessage);
              }
            }
          )
      );
    };

    /**
     * Set the prefix used for creating unique unit paths.
     */
    this.setUniquePathPrefix = function () {
      BulbBusyService.showBusyDuring(
        Restangular.all('devtools/setUniquePathPrefix')
          .post({ 'prefix': that.uniquePathPrefix })
      );
    };

    /**
     * Allows the current user's Org memberships to be removed.  Intended to be used with Off-Boarding testing.
     * Be careful with this one as it can leave a broken chain of inherited groups related to the Organization.
     */
    this.deleteOrgMemberships = function () {
      BulbBusyService.showBusyDuring(
        Restangular.one('/devtools/deleteOrgMemberships').remove()
          .then(function (response) {
            BulbAuthService.setCurrentUser(response);
          }, function (error) {
            BulbErrorService.showError(error);
          })
      );
    };

    /**
     * Allows the user's age verification flag to be reset to desired state for Off-Boarding testing.
     */
    this.toggleAgeVerified = function () {
      BulbBusyService.showBusyDuring(
        Restangular.all('devtools/toggleAgeVerified').post()
          .then(function (response) {
              BulbAuthService.setCurrentUser(response);
            }, function (error) {
              BulbErrorService.error(error);
            }
          )
      );
    };

    /**
     * Toggle if the spam feature is enabled or not when trying to publish.
     */
    this.toggleSpamFeature = function() {
      BulbBusyService.showBusyDuring(
        Restangular.all('devtools/toggleSpamFeature').post()
          .then(function(response) {
            that.spamFeatureEnabled = response.status;
          }, function(error) {
              BulbErrorService.error(error);
          }
        )
      );
    };

    /**
     * Toggle if reCaptcha is enabled/ required on sign-ups.
     */
    this.toggleReCaptcha = function() {
      BulbBusyService.showBusyDuring(
        Restangular.all('devtools/toggleReCaptcha').post()
          .then(function(response) {
              that.reCaptchaEnabled = response.status;
            }, function(error) {
              BulbErrorService.error(error);
            }
          )
      );
    };


    /**
     * Starts the Trickle Upgrader to run asynchronously.
     */
    this.runTrickleUpgrader = function () {
      BulbBusyService.showBusyDuring(
        Restangular.all('devtools/runTrickleUpgrader').post()
          .then(function (response) {
              BulbAuthService.setCurrentUser(response);
            }, function (error) {
              BulbErrorService.error(error);
            }
          )
      );
    };
  }
}
